import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.module.scss';
import Anchor from '../Anchor';
import config from '../../config';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

const LegalLink = ({ className }) => {
  const { t } = useTranslation();
  return (
    <p className={cn(styles.policyPara, className)}>
      <Anchor text="Terms of Service" href={config.termLink} />
      {` `}
      {`${t('and')}`}
      {` `}
      <Anchor text="Privacy Policy" href={config.dataPolicyLink} />
    </p>
  );
};

LegalLink.propTypes = {
  className: PropTypes.string,
};

export default LegalLink;
